import React, { Component } from "react";
import { connect } from "react-redux";
import TemplateWrapper from "../../../cms/areas/template/containers/TemplateLayout/TemplateWrapper";
import { clientTypeConstants } from "../../constants/clientType.constants";
import { HubConnectionBuilder } from "@aspnet/signalr";
import { templateActions } from "../../../store/actions/cms/template/template.action";
import { DragDropContext } from "react-beautiful-dnd";
import { cmsActions } from "../../../store/actions/cms/cms.action";
import { sourceTypes } from "../../../constants/cms/sourceType";
import { WordCloud } from "../other/WordCloud/WordCloud";
import { BarChart } from "../charts/BarChart/BarChart";
import { RatingChart } from "../charts/RatingChart/RatingChart";
import { presenterTypeConstants } from "../../constants/presenterType.constants";
import { PieChart } from "../charts/PieChart/PieChart";
import { TextFlow } from "../other/TextFlow/TextFlow";
import { ColumnChart } from "../charts/ColumnChart/ColumnChart";
import { adjustContentHeight } from "../../../helpers/viewPortHelper";
import { DisparityChart } from "../charts/DisparityChart/DisparityChart";
import Axios from "axios";
import { getKey } from "../../../helpers/UrlHelper";

class PresenterLayout extends Component {
  state = {
    hubConnection: null,
    clientKey: "",
    answer: null,
    question: null,
    availableLanguages: null,
    clientResponses: [],
    presentParticipants: [],
    defaultLanguage: "swe",
    selectedLanguage: null,
    importedAttendees: [],
    error: null,
    sent: false,
    sending: false,
    connected: false,
    fade: false,
    eventId: -1,
    templateId: 0,
    countdown: 0,
    connecting: false,
    presenterSettings: {
      displayTypeText: "TEXTFLOW",
      displayTypeOption: "BARCHART",
      moderationMode: false,
      presentationOrder: "SORTORDER",
      showCount: true,
      showPercent: false,
      showNamesTextflow: false,
    },
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    const eventId = this.props.match.params.id;
    document.body.style.overflow = "hidden";

    if (isNaN(eventId)) {
      this.getEventId(eventId);
    } else {
      this.setState({ eventId }, () => this.connectToHub());
    }
    this.props.dispatch(cmsActions.setEnviroment(sourceTypes.INTERACTION, false));
    const params = new URLSearchParams(window.location.search);
    const lang = params.get(getKey("lang", params));
    if (lang) {
      this.setState({ selectedLanguage: lang });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const { connecting, dismissConnectionLoss, forceDisc, connected } = this.state;

    if (connected == false && prevState.connected == true && connecting == false) {
      this.tryReconnect();
      this.counter = setInterval(() => this.setState({ countdown: this.state.countdown + 1 }), 1000);
    } else if (this.state.countdown >= 60 && !connected && prevState.connected == false) {
      this.setState({ countdown: 0, connecting: false });
      this.tryReconnect();
    } else if (connected == true && prevState.connected == false && !this.state.connecting && this.hubConnection && this.hubConnection.connectionState == 1) {
      if (this.counter) clearInterval(this.counter);
      this.setState({ countdown: 0 });
    }
  }
  getEventId = (eventCode) => {
    Axios.get(`./api/event/getId/${eventCode}`)
      .then((res) => {
        this.setState({ eventId: res.data.id }, () => this.connectToHub());
      })
      .catch((err) => {
        console.error(err);
      });
  };

  onGetOrderList = (list) => {
    this.setState({ importedAttendees: list });
  };
  setClientKey = (key) => {
    localStorage.setItem("CLIENT_KEY", key);
  };
  getClientKey = () => {
    return localStorage.getItem("CLIENT_KEY") || null;
  };
  connectToHub = () => {
    const { eventId } = this.state;
    const { user } = this.props;
    try {
      if (!this.hubConnection) {
        this.hubConnection = new HubConnectionBuilder().withUrl("./ihub").build();
      }
    } catch (error) {
      this.onError(error);
    }
    this.setState({ connecting: true });
    let clientKey = this.getClientKey();
    this.hubConnection
      .start()
      .then(() => {
        this.hubConnection.on("onHandshake", this.onHandshake);
        this.hubConnection.on("onClientResponse", this.onClientResponse);
        this.hubConnection.on("onDeployQuestionToPresenter", this.onDeployQuestionToPresenter);
        this.hubConnection.on("onUpdatedPresenterSettings", this.onUpdatedPresenterSettings);
        this.hubConnection.on("onNewPresentParticipant", this.onNewPresentParticipant);
        this.hubConnection.on("onGetOrderList", this.onGetOrderList);
        this.hubConnection.on("onClearDisplay", this.onClearDisplay);
        this.hubConnection.on("onClearResponses", this.onClearResponses);
        this.hubConnection.on("onClearQuestionAnswers", this.onClearQuestionAnswers);
        this.hubConnection.onclose(() => {
          this.setState({ connected: false });
        });
        this.hubConnection
          .invoke("handshake", {
            eventId,
            clientType: clientTypeConstants.INTERACTION_PRESENTER,
            clientKey,
            userGuid: user ? user.userGuid : null,
          })
          .catch((err) => {
            console.error(err);
          });
      })
      .catch((error) => {
        this.onError(error);
      });
  };
  onNewPresentParticipant = (order) => {
    const { presentParticipants } = this.state;
    if (!presentParticipants.find((x) => x.badgeNo == order.badgeNo)) {
      presentParticipants.push(order);
      this.setState({ presentParticipants });
    }
  };
  onClearResponses = () => {
    this.setState({ clientResponses: [] });
  };

  onUpdatedPresenterSettings = (settings) => {
    this.setState({ presenterSettings: settings });
  };

  onHandshake = (response) => {
    if (response.success) {
      this.hubConnection.invoke("getOrderList", this.state.eventId).catch((err) => {
        this.onError(err);
      });
      if (response.interactionPresenterTemplateId) this.props.dispatch(templateActions.get(response.interactionPresenterTemplateId));
      this.setState({
        connected: true,
        connecting: false,
        templateId: response.interactionPresenterTemplateId,
      });
    } else {
      this.onError(response.message);
    }
  };
  tryReconnect = () => {
    if (!this.state.connected && !this.state.connecting) {
      this.connectToHub();
    }
  };

  onDeployQuestionToPresenter = (response) => {
    let aList = response.answers;

    if (this.state.presenterSettings.displayTypeText === presenterTypeConstants.WORDCLOUD) {
      aList = aList.filter(({ answer }) => answer?.split(" ")?.length === 1);
    }
    this.setState({
      question: response.question,
      clientResponses: aList,
      presentParticipants: response.presentParticipants || [],
    });
  };
  onClearDisplay = () => {
    this.setState({
      question: null,
      clientResponses: [],
    });
  };
  onError = (error) => {
    this.setState({ error });
  };
  convertOptionIdToText = (id) => {
    let optionId = parseInt(id);
    if (isNaN(optionId)) return id;
    const { question, defaultLanguage } = this.state;
    let text = id;

    try {
      text = question.questionOption.find((o) => o.questionOptionId === optionId).questionOptionLanguage.find((l) => l.languageCode === (this.state.selectedLanguage ?? this.state.defaultLanguage)).label;
    } catch (error) {}
    return text;
  };
  onClientResponse = (response) => {
    let responses = Array.from(
      this.state.clientResponses.map((a) => {
        if (a.type === "Option") {
          a.answerText = this.convertOptionIdToText(a.answer);
        }
        return a;
      })
    );
    const existingResponse = responses.find((r) => {
      return r.answerId === response.answerId;
    });
    if (existingResponse && response.status === 3) {
      responses.splice(responses.indexOf(existingResponse), 1);
    }
    if (response.type === "Option") {
      response.answerText = this.convertOptionIdToText(response.answer);
    }
    if (!existingResponse) {
      responses.push(response);
    }
    if (response && this.state.question && response.questionId === this.state.question.questionId) {
      if (this.state.presenterSettings.displayTypeText === presenterTypeConstants.WORDCLOUD && response.type.toUpperCase() === "TEXT") {
        if (response.answer?.split(" ")?.length > 1) return;
        const timeout = setTimeout(() => {
          this.setState({ clientResponses: responses.filter(({ answer }) => answer?.split(" ")?.length === 1) });
          clearTimeout(timeout);
        }, 1500);
      } else {
        this.setState({ clientResponses: responses });
      }
    }
  };
  onClearQuestionAnswers = (res) => {
    if (res) {
      let uptResponses = Array.from(this.state.clientResponses);
      uptResponses = uptResponses.filter((r) => r.questionId !== res);
      this.setState({ clientResponses: uptResponses });
    }
  };
  renderDataVisualizer = () => {
    const { clientResponses, question, presenterSettings } = this.state;

    // const { template } = this.props;
    const { presentationOrder, showPercent, showCount, showNamesTextflow } = presenterSettings;
    let categories = [];
    const template = this.groupTemplate();
    try {
      categories = question.questionOption.map((qo) => {
        return qo.questionOptionLanguage.find((ql) => ql.languageCode === this.state.selectedLanguage || ql.languageCode === this.state.defaultLanguage)?.label || qo.questionOptionLanguage?.[0]?.label;
      });
    } catch (error) {}

    const presenterType = presenterSettings["displayType" + question.type];
    switch (presenterType) {
      case presenterTypeConstants.WORDCLOUD:
        return (
          <WordCloud
            data={clientResponses.map((a) => {
              return a.answer;
            })}
            questionName={question.questionLanguage.find((ql) => ql.languageCode === this.state.selectedLanguage || ql.languageCode === this.state.defaultLanguage)?.label || question.questionLanguage?.[0]?.label}
            template={template}
          />
        );
      case presenterTypeConstants.BARCHART:
        return (
          <BarChart
            data={clientResponses.map((a) => {
              let answer = this.convertOptionIdToText(a.answer);
              return { answer, weight: a.answerWeight };
            })}
            questionName={question.questionLanguage.find((ql) => ql.languageCode === this.state.selectedLanguage || ql.languageCode === this.state.defaultLanguage)?.label || question.questionLanguage?.[0]?.label}
            categories={categories}
            showPercent={showPercent}
            showCount={showCount}
            presentationOrder={presentationOrder}
            template={template}
          />
        );
      case presenterTypeConstants.COLUMNCHART:
        return (
          <ColumnChart
            data={clientResponses.map((a) => {
              let answer = this.convertOptionIdToText(a.answer);
              return { answer, weight: a.answerWeight };
            })}
            categories={categories}
            showPercent={showPercent}
            showCount={showCount}
            presentationOrder={presentationOrder}
            questionName={question.questionLanguage.find((ql) => ql.languageCode === this.state.selectedLanguage || ql.languageCode === this.state.defaultLanguage)?.label || question.questionLanguage?.[0]?.label}
            template={template}
          />
        );
      case presenterTypeConstants.RATING_CHART:
        return (
          <RatingChart
            data={clientResponses.map((a) => {
              let answer = this.convertOptionIdToText(a.answer);
              return answer;
            })}
            questionName={question.questionLanguage.find((ql) => ql.languageCode === this.state.selectedLanguage || ql.languageCode === this.state.defaultLanguage)?.label || question.questionLanguage?.[0]?.label}
            template={template}
          />
        );
      case presenterTypeConstants.DISPARITYCHART:
        return (
          <DisparityChart
            clientList={this.state.clientList}
            clientResponses={clientResponses}
            presentParticipants={this.state.presentParticipants}
            question={question}
            questionName={question.questionLanguage.find((ql) => ql.languageCode === this.state.selectedLanguage || ql.languageCode === this.state.defaultLanguage)?.label || question.questionLanguage?.[0]?.label}
            importedAttendees={this.state.importedAttendees}
            template={template}
          />
        );
      case presenterTypeConstants.PIECHART:
        return (
          <PieChart
            data={clientResponses.map((a) => {
              let answer = this.convertOptionIdToText(a.answer);
              return { answer, weight: a.answerWeight };
            })}
            questionName={question.questionLanguage.find((ql) => ql.languageCode === this.state.selectedLanguage || ql.languageCode === this.state.defaultLanguage)?.label || question.questionLanguage?.[0]?.label}
            categories={categories}
            showPercent={showPercent}
            showCount={showCount}
            presentationOrder={presentationOrder}
            template={template}
          />
        );
      case presenterTypeConstants.TEXTFLOW:
        return (
          <TextFlow
            showNames={showNamesTextflow}
            data={clientResponses.map((a) => {
              return { answer: a.answer, name: a.clientName };
            })}
            questionName={question.questionLanguage.find((ql) => ql.languageCode === this.state.selectedLanguage || ql.languageCode === this.state.defaultLanguage)?.label || question.questionLanguage?.[0]?.label}
            template={template}
          />
        );
      default:
        return null;
    }
  };
  groupTemplate = () => {
    const { template } = this.props;
    if (template === undefined) return null;
    return template.content;
  };
  fadeIn = () => {
    this.setState({ fadeIn: !this.state.fadeIn });
  };
  renderContent = () => {
    const { question } = this.state;
    if (!question) return null;
    return this.renderDataVisualizer();
  };
  render() {
    const { connected } = this.state;
    const { template } = this.props;
    const style = this.groupTemplate();
    if (template === undefined) return null;
    if (!style) return null;
    let h = adjustContentHeight(window.innerHeight, style.content, style.header, style.footer);
    return (
      <React.Fragment>
        <DragDropContext>
          <TemplateWrapper backgroundColor={template.content.content ? template.content.content.backgroundColor : "#fff"}>{this.renderContent()}</TemplateWrapper>
        </DragDropContext>
      </React.Fragment>
    );
  }
}
function mapStateToProps(state) {
  return {
    template: state.template.template,
    user: state.authentication.user,
  };
}
export default connect(mapStateToProps)(PresenterLayout);
